import { RefObject, useEffect } from 'react';

export function useOutsideClick<T extends RefObject<HTMLElement | null>>(
    ref: T,
    callback: () => void,
) {
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                callback();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [callback, ref]);

    return ref;
}
